module.exports = __webpack_public_path__ + "media/images/icons/grey_arrow-3f0c4f4588d29993da3b699b85422abe.svg";